export default __webpack_public_path__ + "static/media/tio.6437a765.png";